<template>
  <section>
    <div id="feedback">
      <div v-if="!thanksPageDisplay">
        <h2>{{title}}</h2>
        <h4>{{description}}</h4>
        <form @submit.prevent="insertFeedback">
          <div class="form-field">
            <!-- <label for="content"></label> -->
            <textarea
              id="content"
              v-model="content"
              :placeholder="contentEg"
              @input="mixin_autoResize_resize"
              @focus="mixin_autoResize_resize"
              required
              autofocus
            />
          </div>
          <div>
            <primary-button :title="'Send'" :act="insertFeedback"></primary-button>
          </div>
        </form>
      </div>
      <div v-if="thanksPageDisplay" class="thanks-modal">
        <h2 class="thanks-title">Thanks!</h2>
        <h4>Thanks for taking the time to help us improve <b>Otti</b>.</h4>
        <primary-button :title="'Send another feedback'" :act="openFeedbackForm"></primary-button>
      </div>
    </div>
  </section>
</template>

<script>
import api from "../../api";

import PrimaryButton from "@/components/shared/PrimaryButton";

import mixinAutoResize from "../../mixins/autoResize.js";

import createFeedback from "../../gql/feedback/createFeedback.gql";

export default {
  data() {
    return {
      content: "",
      contentEg: "I find it ...",
      title: "Leave your feedback",
      description: "Let us know what you think about Otti. How did it help you?",
      thanksPageDisplay: false
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  components: {
    PrimaryButton
  },
  methods: {
    insertFeedback: function() {
      if (this.content == "") return;
      let user_id = this.user.id;
      let content = this.content;
      this.$apollo
        .mutate({
          mutation: createFeedback,
          variables: {
            user_id,
            content
          }
        })
        .then(() => {
          api.sendGenericEmail(
            ["davide.benaroio@gmail.com"],
            "New feedback arrived!",
            this.user.email + " : " + this.content,
            "New feedback arrived from: " + this.user.email
          );
          this.content = "";
          this.thanksPageDisplay = true;
        });
    },
    openFeedbackForm: function() {
      this.thanksPageDisplay = false;
    }
  },
  mixins: [mixinAutoResize]
};
</script>

<style scoped lang="scss">
@use '@/styles/theme.scss';

@import "@/styles/form.scss";

.page-title {
  margin-top: 40px;
  margin-bottom: 40px;
}

form {
  margin-top: 40px;
}

.form-field > * {
  display: block;
  margin-bottom: 20px;
}

.form-field textarea {
  border: 1px solid theme.$text-color;
  padding: 6px 8px;
  width: 100%;
  outline: none;
  max-height: 220px;
  resize: vertical;
  font-size: 14px;
  font-weight: 200;
  min-height: 6em;
}

.primary-button {
  margin-top: top 30px;
  text-align: center;
}

.thanks-title {
  margin-bottom: 40px;
}
</style> 